import Axios from "../config/axios-config";
import { errorHandler } from "../utils/errorHandler";

export const sendDriverPushNotification = async (payload) => {
  try {
    const response = await Axios.post(`notifications/driver`, payload);
    return { success: true, data: response.data, error: null };
  } catch (err) {
    // No toast here: the panel renders the message in its own banner, so a
    // toast would duplicate it. fallbackMessage only kicks in when the backend
    // sends no text of its own — otherwise its reason (e.g. 'No hay tokens de
    // notificación disponibles') reaches the banner.
    const errorInfo = errorHandler.handleApiError(err, {
      showNotification: false,
      fallbackMessage: "No se pudo enviar la notificación push a repartidores.",
      context: "Notificaciones a repartidores",
    });

    return { success: false, data: null, error: errorInfo };
  }
};

export const getNotificationLogs = async (page = 1, limit = 20) => {
  try {
    const response = await Axios.get(`notifications/logs`, { params: { page, limit } });
    return { success: true, data: response.data, error: null };
  } catch (err) {
    const errorInfo = errorHandler.handleApiError(err, {
      showNotification: false,
      context: "Historial de notificaciones",
    });
    return { success: false, data: null, error: errorInfo };
  }
};

